import { useEffect, useState } from "react";
import CollectionDialog from "./components/CollectionDialog";
import API from "./API";
import ErrorPopup from "./components/ErrorPopup";
import PromoPumaTextField from "./components/PromoPumaTextField";
import TimerDialog from "./components/TimerDialog";

function App() {
	const [discount, setDiscount] = useState("");
	const [appliedDiscounts, setAppliedDiscounts] = useState(API.getStorage() || []);
	const [dialog, setDialog] = useState(false);
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);
	const [autoCodes, setAutoCodes] = useState([]);
	const [cart, setCart] = useState(window.SideCart.cart);
	const update = window.SideCart.update;

	useEffect(() => {
		// TODO -- GET AUTO CODES
		setAutoCodes([
			{
				compare_at_price: 1000,
				name: "AUTOFREETOY",
				auto: true,
				active: true,
				hidden: true,
				variantId: "40303847669849",
				conditions: [
					{
						field: "codes",
						op: ">=",
						value: 1,
					},
					{
						error: "",
						op: ">",
						field: "cart.total_price",
						value: 2500,
					},
				],
				steps: [
					{
						type: "addToCart",
						variantId: "40303847669849",
					},
				],
			},
			{
				compare_at_price: 1000,
				name: "AUTOFREEPOOPBAGHOLDER",
				auto: true,
				active: true,
				hidden: true,
				variantId: "40303852421209",
				conditions: [
					{
						field: "codes",
						op: ">=",
						value: 1,
					},
					{
						error: "",
						op: ">",
						field: "cart.total_price",
						value: 8000,
					},
				],
				steps: [
					{
						type: "addToCart",
						variantId: "40303852421209",
					},
				],
			},
		]);

		const watcher = window.SideCart.onUpdate(setCart);
		return () => watcher();
	}, []);

	const handleChange = ({ target }) => {
		setError(false);
		setDiscount(target.value.toUpperCase());
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (appliedDiscounts?.find((d) => d.name === discount)) {
			setError("Promo Code Already Applied");
			return;
		}

		setLoading(true);
		fetch(`/apps/promopuma?code=${discount}`)
			.then((r) => {
				setLoading(false);
				if (r.status === 200) {
					r.json().then((code) => {
						if (!code.stackable && appliedDiscounts.filter((d) => !d.auto).filter((d) => !code.exceptions.includes(d.id)).length) return setError("Only one discount code may be used.");
						// if (code.active !== 'undefined' && !code.active) return setError("Promo Code Not Found");

						const cartTotal = window.SideCart.cartTotal ?? cart.total ?? window.SideCart.getCartTotal();

						const conditionResults = code.conditions
							.map((cond) => {
								if (operator[cond.op](cartTotal, cond.value)) {
									return false;
								} else {
									return cond.error || cond.errorMessage; // TODO --  remove errorMessage fallback
								}
							})
							.filter(Boolean);

						if (conditionResults.length) {
							setError(conditionResults[0]);
							return;
						}

						if (code.steps.length) {
							for (const step of code.steps) {
								if (step.type === "modal") {
									setDialog({ step, code });
								}
								if (step.type === "timer") {
									code.timer = Date.now() + step.time * 60 * 1000;
									setDialog({ step, code });
								}
							}
						} else {
							setAppliedDiscounts((d = []) => [...d, { name: discount, ...code }]);
							setDiscount("");
						}
					});
				} else {
					setError("Promo Code Not Found");
				}
			})
			.finally(() => setLoading(false));

		return false;
	};

	const handleRemoveDiscount =
		(discountToRemove) =>
		(...a) => {
			update({ [discountToRemove.variantId]: { set: 0 } }).then(() => {
				setAppliedDiscounts((d) => {
					const dd = d.filter((dd) => dd.name !== discountToRemove.name);
					window.SideCart.setDiscount(dd.find((d) => d.code)?.code);
					return dd;
				});
			});
		};

	const addToCart = (variant, code, properties = {}) => {
		setLoading(true);
		update({ [variant.id]: { set: 1, properties } })
			.then((cart) => {
				window.SideCart.setDiscount(discount);
				setAppliedDiscounts((d = []) => [...d, { name: discount, variantId: variant.id, ...code }]);
				setDiscount("");
				setDialog(false);
			})
			.catch(console.error)
			.finally(() => setLoading(false));
	};

	useEffect(() => {
		// UPDATE STORAGE &&  CART TRANSFORMS
		console.log("APPLIED", appliedDiscounts);
		if (appliedDiscounts) {
			API.setStorage(appliedDiscounts);
		}

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
		window.SideCart.setCartTransforms((filters) => {
			// [{ id, func}]
			filters = filters.filter((f) => !/promopuma/.test(f.id));

			for (const code of appliedDiscounts) {
				const id = "promopuma-" + code.name;
				const func = (cartItems) => {
					return cartItems.map((item) => {
						if (!code.exclusions?.includes(String(item.product_id))) {
							const discountAmount = (item.total * code.discountPercentage) / -100 || 0;
							item.total = item.total - discountAmount;
							item.savings += discountAmount;
							if (item.price !== item.total) item.compare_at_price = item.price;
							if (code.variantId === item.id) {
								item.savings += code.compare_at_price;
								item.compare_at_price = code.compare_at_price;
							}
						}
						return { ...item };
					});
				};
				filters.push({ id, func });
			}

			return filters;
		});
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	}, [appliedDiscounts]);

	useEffect(() => {
		// CONDITIONS AND SAVINGS
		console.log({ cart, appliedDiscounts });
		if (cart && appliedDiscounts) {
			for (const d of appliedDiscounts) {
				// CHECK CONDITIONS

				const errors = d.conditions
					.map((cond) => {
						if (cond.field === "cart.total_price") {
							if (operator[cond.op](cart.total, cond.value)) {
								return false;
							} else {
								return cond.error || cond.errorMessage || true;
							}
						} else if (cond.field === "codes") {
							if (operator[cond.op](appliedDiscounts.length, cond.value)) {
								return false;
							} else {
								return cond.error || cond.errorMessage || true;
							}
						} else return false;
					})
					.filter(Boolean);

				if (errors.length) {
					handleRemoveDiscount(d)();
					continue;
				}
			}
		}
		window.SideCart.setDiscount(appliedDiscounts?.find((d) => d.code)?.code);
	}, [cart, appliedDiscounts]);

	useEffect(() => {
		// AUTO CODES
		if (cart && autoCodes && appliedDiscounts) {
			const codes = autoCodes.filter((c) => !appliedDiscounts.map((d) => d.name).includes(c.name));
			for (const code of codes) {
				const conditions = code.conditions.every((cond) => {
					if (cond.field === "cart.total_price") {
						return cart.total > cond.value;
					} else if (cond.field === "codes") {
						return appliedDiscounts.length >= cond.value;
					} else return false;
				});

				if (conditions) {
					for (const step of code.steps) {
						if (step.type === "addToCart") {
							setAppliedDiscounts((a) => [...a, { ...code, variantId: code.steps[0].variantId }]);
							update({ [step.variantId]: { set: 1 } });
						}
					}
				}
			}
		}
	}, [autoCodes, appliedDiscounts, cart]);

	return (
		<>
			<PromoPumaTextField {...{ discount, setDiscount, handleChange, handleRemoveDiscount, loading, handleSubmit, appliedDiscounts }} />
			<CollectionDialog {...{ dialog, setDialog, addToCart, loading }} />
			<TimerDialog {...{ dialog, setDialog, addToCart, loading }} />
			<ErrorPopup {...{ error, discount, onClose: () => setDiscount("") || setError(false) }} />
		</>
	);
}

export default App;

const operator = {
	"<": (a, b) => a < b,
	">": (a, b) => a > b,
	"<=": (a, b) => a <= b,
	">=": (a, b) => a >= b,
	"==": (a, b) => a === b,
};
